export default __webpack_public_path__ + "static/media/client-20.48fbc4c6.png";